"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[383],{

/***/ 90884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ ProductLoop; },
  "P": function() { return /* binding */ ProductLoopLoading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./libs/app/index.ts
var app = __webpack_require__(92517);
// EXTERNAL MODULE: ./components/index.ts + 87 modules
var components = __webpack_require__(83554);
// EXTERNAL MODULE: ./components/ui/NewGallery/index.tsx
var NewGallery = __webpack_require__(23303);
;// CONCATENATED MODULE: ./components/ui/SkeletonLoading/index.tsx


var SkeletonLoading = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(className, " skeleton")
    });
};
/* harmony default export */ var ui_SkeletonLoading = (SkeletonLoading);

;// CONCATENATED MODULE: ./components/loop/ProductLoop.tsx







var ProductLoop = function(props) {
    var ref, ref1, ref2;
    var p = props.p, t = props.t, catCode = props.catCode, isShowOriginPrice = props.isShowOriginPrice;
    var handle = "".concat((0,app/* createHandle */.UR)(p.product_name), "-").concat(p.id, "-").concat(p.product_code);
    var isDiscount = p.product_discount ? (0,app/* checkTime */.s)((ref = p.product_discount) === null || ref === void 0 ? void 0 : ref.started_at, (ref1 = p.product_discount) === null || ref1 === void 0 ? void 0 : ref1.ended_at) : false;
    if (p.product_discount && ((ref2 = p.product_discount) === null || ref2 === void 0 ? void 0 : ref2.status) === shared/* DiscountStatus.Ended */.YT.Ended) isDiscount = false;
    var isDeposited = p.quantity <= 0 || p.status == shared/* ProductStatus.CloseASale */.Pt.CloseASale || p.status === shared/* ProductStatus.Deposited */.Pt.Deposited;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full tw-h-full tw-bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-rounded-5 tw-border tw-border-gray-70 tw-overflow-hidden tw-w-full tw-h-full hover:tw-border-primary-main tw-duration-500 tw-ease-linear",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-w-full p-100p tw-relative tw-leading-0 tw-h-0 tw-bg-secondary-20",
                    children: [
                        p.images && p.images.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewGallery/* default */.Z, {
                                images: p.images
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                            className: "tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0",
                            alt: p.product_name,
                            src: p.images && p.images[0] ? p.images[0].url : "/bg-default.png"
                        }),
                        p.product_discount && isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-7 tw-h-7 tw-absolute tw-top-3 tw-right-3 tw-z-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: "/sale.png",
                                    className: "tw-w-full tw-h-full",
                                    alt: "sale"
                                })
                            })
                        }),
                        p.is_auction && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-7 tw-h-7 tw-absolute tw-top-3 tw-right-3 tw-z-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: "/auction.png",
                                    className: "tw-w-full tw-h-full",
                                    alt: "auction"
                                })
                            })
                        }),
                        isDeposited && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-absolute tw-z-10",
                            style: {
                                top: "8px",
                                left: "0"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PentagonIcon */.nM, {
                                    text: "Đ\xe3 b\xe1n"
                                }),
                                " "
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-pt-4 tw-pb-5",
                    children: [
                        catCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                            url: {
                                pathname: shared/* PagePath.CategoryProductPage */._.CategoryProductPage,
                                query: {
                                    id: catCode,
                                    slug: handle
                                }
                            },
                            className: "tw-h-12 md:tw-h-12 tw-px-1 tw-text-base tw-font-semibold tw-text-primary-main tw-w-full tw-line-clamp-2 tw-text-center",
                            children: p.product_name
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                            url: {
                                pathname: shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                                query: {
                                    id: handle
                                }
                            },
                            className: "tw-h-12 md:tw-h-12 tw-px-1 tw-text-base tw-font-semibold tw-text-primary-main tw-w-full tw-line-clamp-2 tw-text-center",
                            children: p.product_name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-secondary-81 tw-font-light tw-text-sm md:tw-text-base tw-line-clamp-1 tw-px-1",
                                    children: p.product_code
                                }),
                                p.quotation ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-text-secondary-70",
                                    children: "Li\xean hệ"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: p.is_auction && p.auction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                            children: (0,app/* toMoney */.KP)(p.auction.status === shared/* AuctionStatus.Pending */.wo.Pending ? p.auction.origin_price || 0 : p.auction.sell_price || 0, t, shared/* PriceSymbol.$ */.hb.$)
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: p.product_discount && isDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                isShowOriginPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-block tw-mt-1 tw-text-secondary-81 tw-font-light tw-text-sm tw-line-through tw-italic",
                                                    children: (0,app/* toMoney */.KP)(p.price, t, shared/* PriceSymbol.$ */.hb.$)
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                                    children: (0,app/* toMoney */.KP)(p.price - p.price * p.product_discount.discount / 100, t, shared/* PriceSymbol.$ */.hb.$)
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                                children: (0,app/* toMoney */.KP)(p.price, t, shared/* PriceSymbol.$ */.hb.$)
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var ProductLoopLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full tw-h-full tw-bg-white tw-border tw-border-gray-70",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-rounded-5 tw-overflow-hidden tw-w-full tw-h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-w-full p-100p tw-relative tw-h-0 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SkeletonLoading, {
                        className: "tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-pt-4 tw-pb-5 tw-px-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SkeletonLoading, {
                            className: "tw-h-12 md:tw-h-12 tw-rounded"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-text-center tw-mt-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SkeletonLoading, {
                                    className: "tw-h-6 tw-rounded"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SkeletonLoading, {
                                    className: "tw-h-6 tw-mt-1 tw-rounded"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 34794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83554);
/* harmony import */ var _contexts_profile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48309);




var TitlePartial = function(param) {
    var name = param.name, className = param.className, cs = param.cs;
    var masterData = (0,_contexts_profile__WEBPACK_IMPORTED_MODULE_3__/* .useMasterData */ .AE)();
    var theme = (masterData !== null && masterData !== void 0 ? masterData : {}).theme;
    var icon_category_url = (theme !== null && theme !== void 0 ? theme : {}).icon_category_url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "_title tw-text-lg md:tw-text-2xl tw-flex tw-items-center tw-justify-center  tw-w-full  tw-relative ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-items-center tw-w-max tw-px-5 tw-justify-center ",
            children: [
                icon_category_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: icon_category_url,
                    alt: "star",
                    className: "tw-h-8 tw-w-8"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: "/diamond.svg",
                    alt: "star",
                    className: "tw-h-5 tw-w-5"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "tw-flex-1 tw-block tw-px-4 tw-uppercase tw-text-primary-main tw-font-semibold ".concat(cs),
                    children: name
                }),
                icon_category_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: icon_category_url,
                    alt: "star",
                    className: "tw-h-8 tw-w-8"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: "/diamond.svg",
                    alt: "star",
                    className: "tw-h-5 tw-w-5"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(TitlePartial));


/***/ }),

/***/ 52685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ui_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34794);
/* harmony import */ var _components_loop_ProductLoop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90884);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7806);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83554);






var NewProduct = function(param) {
    var title = param.title, description = param.description, products = param.products, t = param.t, cateCode = param.cateCode, isHideSeeMore = param.isHideSeeMore;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                name: title,
                className: "_title-product-detail tw-text-lg tw-text-center md:tw-text-2xl",
                cs: "tw-w-40 md:tw-w-auto"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "tw-text-xl tw-text-secondary-70 tw-text-center tw-line-clamp-2 lg:tw-w-4/5 tw-mx-auto",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-2 tw-mt-10 lg:tw-gap-4",
                children: products.map(function(p, index) {
                    return [
                        0,
                        1,
                        2,
                        3
                    ].includes(index) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loop_ProductLoop__WEBPACK_IMPORTED_MODULE_3__/* .ProductLoop */ ._, {
                            catCode: p.cat_code,
                            p: p,
                            t: t
                        })
                    }, p.product_code);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-mt-10 tw-text-center tw-text-md ".concat(isHideSeeMore && "tw-hidden"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, {
                    className: "tw-italic tw-text-center !tw-underline",
                    url: {
                        pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_4__/* .PagePath.CategoryPage */ ._.CategoryPage,
                        query: {
                            id: cateCode
                        }
                    },
                    children: t("detail.label.seemore")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(NewProduct));


/***/ }),

/***/ 60383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ list; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(74931);
// EXTERNAL MODULE: ./features/products/list/partials/main/index.tsx
var main = __webpack_require__(71319);
;// CONCATENATED MODULE: ./features/products/list/util.ts


var productsQueryBuilder = function(data) {
    var limit = data.limit, offset = data.offset, color = data.color, gem_type = data.gem_type, gem_pure = data.gem_pure, gem_material = data.gem_material, jewelry_material = data.jewelry_material, cat_code = data.cat_code, product_keyword = data.product_keyword, price = data.price, quotation = data.quotation, sort_by = data.sort_by, tags = data.tags;
    var payload = {};
    if (gem_type) {
        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            gem_type: gem_type
        });
    }
    if (gem_pure) {
        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            gem_pure: gem_pure
        });
    }
    if (tags) {
        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            tags: tags
        });
    }
    if (gem_material) {
        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            gem_material: gem_material
        });
    }
    if (jewelry_material) {
        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            jewelry_material: jewelry_material
        });
    }
    if (product_keyword) {
        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            product_keyword: product_keyword
        });
    }
    if (cat_code) {
        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            cat_code: cat_code
        });
    }
    if (sort_by) {
        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            sort_by: sort_by
        });
    }
    if (color) {
        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            color: color
        });
    }
    if (price) {
        if (price === "true" || price === "false") {
            payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                quotation: price
            });
        } else payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            price: price,
            quotation: "false"
        });
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
        limit: limit,
        offset: offset
    });
};
var initMasterData = function(masterData) {
    var result = {
        gem_material: [],
        jewelry_material: [],
        gem_type: [],
        color: [],
        gem_pure: []
    };
    var ProductInputKeys = Object.keys(result);
    if (Array.isArray(masterData)) {
        return masterData.reduce(function(acc, param) {
            var key = param.key, data = param.data;
            if (ProductInputKeys.includes(key)) {
                acc[key] = data;
            }
            return acc;
        }, result);
    }
    return result;
};
var initMasterDataCustom = function(masterData) {
    var result = {
        gem_type: [],
        color: []
    };
    var ProductInputKeys = Object.keys(result);
    if (Array.isArray(masterData)) {
        return masterData.reduce(function(acc, param) {
            var key = param.key, data = param.data;
            if (ProductInputKeys.includes(key)) {
                acc[key] = data;
            }
            return acc;
        }, result);
    }
    return result;
};
var buildDropdownOptions = function(data) {
    if (!Array.isArray(data)) {
        return [];
    }
    return data.map(function(key) {
        return {
            value: key,
            text: key
        };
    });
};

// EXTERNAL MODULE: ./components/index.ts + 87 modules
var components = __webpack_require__(83554);
;// CONCATENATED MODULE: ./features/products/list/const.ts
var ReducerType;
(function(ReducerType) {
    ReducerType["OnPageChange"] = "OnPageChange";
    ReducerType["OnColorChange"] = "OnColorChange";
    ReducerType["OnFilterReset"] = "OnFilterReset";
    ReducerType["OnGemTypeChange"] = "OnGemTypeChange";
    ReducerType["OnGemPureChange"] = "OnGemPureChange";
    ReducerType["OnKeywordChange"] = "OnKeywordChange";
    ReducerType["OnCategoryChange"] = "OnCategoryChange";
    ReducerType["OnGemMaterialChange"] = "OnGemMaterialChange";
    ReducerType["OnAllChange"] = "OnAllChange";
    ReducerType["OnJewelryMaterialChange"] = "OnJewelryMaterialChange";
    ReducerType["OnPriceChange"] = "OnPriceChange";
    ReducerType["OnTagChange"] = "OnTagChange";
    ReducerType["OnQuotationChange"] = "OnQuotationChange";
    ReducerType["OnSortBy"] = "OnSortBy";
})(ReducerType || (ReducerType = {}));
var KeyFilter;
(function(KeyFilter) {
    KeyFilter["Color"] = "color";
    KeyFilter["GemMaterial"] = "gem_material";
    KeyFilter["JewelryMaterial"] = "jewelry_material";
    KeyFilter["GemType"] = "gem_type";
    KeyFilter["GemPure"] = "gem_pure";
    KeyFilter["Price"] = "price";
    KeyFilter["Quotation"] = "quotation";
    KeyFilter["SortBy"] = "sort_by";
})(KeyFilter || (KeyFilter = {}));
/**
 * default !value
 */ var CategoryDefault = "MOI";
var ProductInputKeys = [
    "gem_material",
    "jewelry_material",
    "gem_pure",
    "gem_type",
    "color"
];
var CursorDefault = {
    edges: [],
    count: 0
};
var priceFilter = [
    {
        value: "",
        text: "Tất cả"
    },
    {
        value: "0,10000000",
        text: "Dưới 10 triệu"
    },
    {
        value: "10000001,40000000",
        text: "Từ 10 đến 40 triệu"
    },
    {
        value: "40000001,80000000",
        text: "Từ 40 đến 80 triệu"
    },
    {
        value: "80000001,100000000000",
        text: "Tr\xean 80 triệu"
    },
    {
        value: "true",
        text: "Li\xean hệ"
    }, 
];

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(65820);
// EXTERNAL MODULE: ./libs/app/index.ts
var app = __webpack_require__(92517);
;// CONCATENATED MODULE: ./features/products/list/partials/filter/index.tsx










var FilterPartial = function(param) {
    var state = param.state, dispatch = param.dispatch, masterDataPearl = param.masterDataPearl, masterData = param.masterData, t = param.t;
    var Router = (0,router.useRouter)();
    var ref = (0,react.useState)(false), isShow = ref[0], setShow = ref[1];
    var onKeywordChange = function(value) {
        dispatch({
            type: ReducerType.OnPageChange,
            payload: 1
        });
        if (value.includes("#")) {
            dispatch({
                type: ReducerType.OnTagChange,
                payload: value.replace("#", "")
            });
        } else dispatch({
            type: ReducerType.OnKeywordChange,
            payload: value
        });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var optimizedFn = (0,react.useCallback)((0,app/* debounce */.Ds)(onKeywordChange, 300), []);
    var sortByOptions = [
        {
            text: t("list.filter.date-dsc"),
            value: "created_at|desc"
        },
        {
            text: t("list.filter.price-asc"),
            value: "price|asc"
        },
        {
            text: t("list.filter.price-desc"),
            value: "price|desc"
        }, 
    ];
    var resetPage = function() {
        Router.push({
            pathname: Router.pathname,
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Router.query), {
                page: 1
            })
        }, undefined, {
            shallow: true
        });
        dispatch({
            type: ReducerType.OnPageChange,
            payload: 1
        });
    };
    var onGemTypeChange = function(value) {
        resetPage();
        return dispatch({
            type: ReducerType.OnGemTypeChange,
            payload: value
        });
    };
    var onGemPureChange = function(value) {
        resetPage();
        return dispatch({
            type: ReducerType.OnGemPureChange,
            payload: value
        });
    };
    var onColorChange = function(value) {
        resetPage();
        return dispatch({
            type: ReducerType.OnColorChange,
            payload: value
        });
    };
    var onGemMaterialChange = function(value) {
        resetPage();
        return dispatch({
            type: ReducerType.OnGemMaterialChange,
            payload: value
        });
    };
    var onPriceChange = function(value) {
        resetPage();
        return dispatch({
            type: ReducerType.OnPriceChange,
            payload: value
        });
    };
    var onJewelryMaterialChange = function(value) {
        resetPage();
        return dispatch({
            type: ReducerType.OnJewelryMaterialChange,
            payload: value
        });
    };
    var onChangeSort = function(e) {
        return dispatch({
            type: ReducerType.OnSortBy,
            payload: e
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:tw-flex tw-flex-col tw-gap-y-6 tw-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-grid tw-grid-cols-1 md:tw-grid-cols-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:tw-col-span-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                        value: state.gem_material,
                                        onChange: onGemMaterialChange,
                                        className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                        options: buildDropdownOptions(masterData.gem_material),
                                        classDr: "tw-border-0 !tw-bg-white tw-text-base",
                                        children: t("list.filter.gem-material")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                        value: state.jewelry_material,
                                        className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                        onChange: onJewelryMaterialChange,
                                        options: buildDropdownOptions(masterData.jewelry_material),
                                        classDr: "!tw-border-0 !tw-bg-white tw-text-base",
                                        children: t("list.filter.jewelry-material")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                        value: state.color,
                                        onChange: onColorChange,
                                        className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                        options: state.cat_code !== "NGOCTRAI" ? buildDropdownOptions(masterData.color) : buildDropdownOptions(masterDataPearl.color),
                                        classDr: "!tw-border-0 !tw-bg-white tw-text-base",
                                        children: t("list.filter.color")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                        value: state.gem_pure,
                                        className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                        onChange: onGemPureChange,
                                        options: buildDropdownOptions(masterData.gem_pure),
                                        classDr: "!tw-border-0 !tw-bg-white tw-text-base",
                                        children: t("list.filter.gem-pure")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                        value: state.gem_type,
                                        onChange: onGemTypeChange,
                                        className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                        options: state.cat_code !== "NGOCTRAI" ? buildDropdownOptions(masterData.gem_type) : buildDropdownOptions(masterDataPearl.gem_type),
                                        classDr: "tw-border-0 !tw-bg-white tw-text-base",
                                        children: t("list.filter.gem-type")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                        value: state.price,
                                        onChange: onPriceChange,
                                        className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                        options: priceFilter,
                                        classDr: "tw-border-0 !tw-bg-white tw-text-base",
                                        children: t("list.filter.price")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:tw-col-span-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:tw-col-span-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                value: state.sort_by,
                                onChange: onChangeSort,
                                className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                options: sortByOptions,
                                classDr: "tw-border-0 !tw-bg-white tw-text-base",
                                children: t("list.filter.sort-by")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-block md:tw-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-gap-x-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Input */.II, {
                                onChange: function(e) {
                                    return optimizedFn(e.target.value);
                                },
                                // variant={InputVariant.Outlined}
                                value: state.product_keyword,
                                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    className: "tw-text-secondary-70",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SearchIcon */.W1, {})
                                }),
                                placeholder: t("list.filter.keyword"),
                                containerClassName: "tw-bg-white tw-rounded-5 tw-w-full sm:tw-w-full tw-text-primary-main tw-border tw-border-primary-main tw-py-2 tw-px-3",
                                className: "tw-text-secondary-70"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-flex-col tw-items-center tw-text-primary-main tw-w-10",
                                onClick: function() {
                                    return setShow(!isShow);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FilterIcon */.k1, {}),
                                        className: "tw-h-7 tw-w-7"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-text-10",
                                        children: t("list.label.filter-mobile")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        children: isShow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Modal */.u_, {
                            className: "!tw-w-full !tw-rounded-none !tw-px-4 !tw-h-full tw-flex tw-flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* ModalHeader */.xB, {
                                    className: "tw-relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-text-center tw-font-medium tw-text-secondary-70 tw-uppercase",
                                            children: t("list.label.filter-mobile")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-absolute tw-top-0 tw-right-0",
                                            onClick: function() {
                                                return setShow(!isShow);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                className: "tw-tw-6 tw-h-6 tw-p-1",
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* XLineIcon */.pC, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* ModalBody */.fe, {
                                    className: "tw-flex tw-flex-col tw-gap-y-6 tw-pt-6 tw-flex-1 tw-h-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                            value: state.gem_material,
                                            onChange: onGemMaterialChange,
                                            className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                            options: buildDropdownOptions(masterData.gem_material),
                                            classDr: "tw-border-0 !tw-bg-white tw-text-base",
                                            children: t("list.filter.gem-material")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                            value: state.jewelry_material,
                                            className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                            onChange: onJewelryMaterialChange,
                                            options: buildDropdownOptions(masterData.jewelry_material),
                                            classDr: "!tw-border-0 !tw-bg-white tw-text-base",
                                            children: t("list.filter.jewelry-material")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                            value: state.color,
                                            onChange: onColorChange,
                                            className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                            options: state.cat_code !== "NGOCTRAI" ? buildDropdownOptions(masterData.color) : buildDropdownOptions(masterDataPearl === null || masterDataPearl === void 0 ? void 0 : masterDataPearl.color),
                                            classDr: "!tw-border-0 !tw-bg-white tw-text-base",
                                            children: t("list.filter.color")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                            value: state.gem_type,
                                            onChange: onGemTypeChange,
                                            className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                            options: state.cat_code !== "NGOCTRAI" ? buildDropdownOptions(masterData.gem_type) : buildDropdownOptions(masterDataPearl === null || masterDataPearl === void 0 ? void 0 : masterDataPearl.gem_type),
                                            classDr: "tw-border-0 !tw-bg-white tw-text-base",
                                            children: t("list.filter.gem-type")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                            value: state.price,
                                            onChange: onPriceChange,
                                            className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                            options: priceFilter,
                                            classDr: "tw-border-0 !tw-bg-white tw-text-base",
                                            children: t("list.filter.price")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dropdown */.Lt, {
                                            value: state.sort_by,
                                            onChange: onChangeSort,
                                            className: "tw-border tw-rounded-5 custom-border-v2 md:tw-w-full tw-py-1 tw-px-2",
                                            options: sortByOptions,
                                            classDr: "tw-border-0 !tw-bg-white tw-text-base",
                                            children: t("list.filter.sort-by")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalFooter */.mz, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                        onClick: function() {
                                            return setShow(!isShow);
                                        },
                                        className: "tw-w-full tw-text-base tw-text-white tw-bg-primary-main !tw-rounded-5",
                                        children: t("list.label.filter-product")
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var filter = (FilterPartial);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95298);
// EXTERNAL MODULE: ./features/products/list/api.ts
var api = __webpack_require__(81525);
;// CONCATENATED MODULE: ./features/products/list/reducer.ts




var initialState = {
    limit: 20,
    offset: 0,
    color: "",
    gem_type: "",
    gem_pure: "",
    gem_material: "",
    product_keyword: "",
    jewelry_material: "",
    cat_code: CategoryDefault,
    price: "",
    tags: "",
    quotation: "",
    sort_by: ""
};
var reducer = function(state, action) {
    switch(action.type){
        case ReducerType.OnPageChange:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                offset: (0,app/* getPageQuery */.uH)(action.payload, initialState.limit)
            });
        case ReducerType.OnColorChange:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                color: action.payload
            });
        case ReducerType.OnGemTypeChange:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                gem_type: action.payload
            });
        case ReducerType.OnGemPureChange:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                gem_pure: action.payload
            });
        case ReducerType.OnGemMaterialChange:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                gem_material: action.payload
            });
        case ReducerType.OnJewelryMaterialChange:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                jewelry_material: action.payload
            });
        case ReducerType.OnKeywordChange:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                product_keyword: action.payload
            });
        case ReducerType.OnCategoryChange:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                cat_code: action.payload
            });
        case ReducerType.OnAllChange:
            return (0,_object_spread/* default */.Z)({}, state, action.payload);
        case ReducerType.OnPriceChange:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                price: action.payload
            });
        case ReducerType.OnQuotationChange:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                quotation: action.payload
            });
        case ReducerType.OnTagChange:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                tags: action.payload
            });
        case ReducerType.OnSortBy:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                sort_by: action.payload
            });
        case ReducerType.OnFilterReset:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                limit: 20,
                offset: 0,
                color: "",
                gem_type: "",
                gem_pure: "",
                gem_material: "",
                product_keyword: "",
                jewelry_material: "",
                price: "",
                sort_by: "",
                tags: ""
            });
        default:
            return (0,_object_spread/* default */.Z)({}, initialState);
    }
};

// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 171 modules
var motion = __webpack_require__(15331);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(13390);
// EXTERNAL MODULE: ./features/products/detail/partials/RelatedProduct/index.tsx
var RelatedProduct = __webpack_require__(52685);
;// CONCATENATED MODULE: ./features/products/list/layout.tsx






















var ProductListLayout = function(param) {
    var categories = param.categories, masterData = param.masterData, masterDataPearl = param.masterDataPearl, category = param.category;
    var ref, ref1;
    var t = (0,esm/* useTranslation */.$G)([
        "product",
        "layout"
    ]).t;
    var Router = (0,router.useRouter)();
    var ref2 = (0,react.useReducer)(reducer, initialState), state = ref2[0], dispatch = ref2[1];
    var ref3 = (0,react.useState)(CursorDefault), cursor = ref3[0], setCursor = ref3[1];
    var ref4 = (0,react.useState)([]), newestProducts = ref4[0], setNewestProducts = ref4[1];
    (0,react.useEffect)(function() {
        if (Router.query.page) {
            dispatch({
                type: ReducerType.OnPageChange,
                payload: +Router.query.page
            });
        } else {
            dispatch({
                type: ReducerType.OnPageChange,
                payload: 1
            });
        }
        if (Router.query.id) {
            var _p = Router.query.id + "";
            dispatch({
                type: ReducerType.OnCategoryChange,
                payload: _p.toUpperCase()
            });
        } else {
            if (Router.query.tag) dispatch({
                type: ReducerType.OnCategoryChange,
                payload: ""
            });
            else dispatch({
                type: ReducerType.OnCategoryChange,
                payload: CategoryDefault
            });
        }
        if (Router.query.tag) {
            dispatch({
                type: ReducerType.OnTagChange,
                payload: Router.query.tag + ""
            });
        } else {
            dispatch({
                type: ReducerType.OnTagChange,
                payload: ""
            });
        }
        dispatch({
            type: ReducerType.OnKeywordChange,
            payload: Router.query.keyword || ""
        });
    }, [
        Router.query
    ]);
    var ref5 = (0,api/* useFetchProductsQuery */.DU)(productsQueryBuilder(state), {
        refetchOnWindowFocus: false,
        enabled: false,
        retry: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data, totalRecords = param.total_records;
            var edges = Array.isArray(data) ? data : [];
            setCursor({
                edges: edges,
                count: +totalRecords
            });
        }
    }), refetch = ref5.refetch, isLoading = ref5.isLoading;
    (0,react.useEffect)(function() {
        refetch();
    }, [
        refetch,
        state
    ]);
    var ref6 = (0,api/* useFetchProductsQuery */.DU)({
        limit: 10,
        offset: 0,
        sort_by: "created_at|desc"
    }, {
        refetchOnWindowFocus: false,
        enabled: false,
        retry: false,
        onError: function(param) {
            var message = param.message;
        },
        onSuccess: function(param) {
            var data = param.data;
            console.log("data: ", data);
            setNewestProducts(Array.isArray(data) ? data : []);
        }
    }), refetchNewestProducts = ref6.refetch;
    (0,react.useEffect)(function() {
        console.log("fetch");
        refetchNewestProducts();
    }, [
        refetchNewestProducts
    ]);
    var onPageChange = function(page) {
        var // window.scrollTo({ top: 0, left: 0 });
        ref;
        (ref = document.getElementById("main-category")) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
        Router.push({
            pathname: Router.pathname,
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Router.query), {
                page: page
            })
        }, undefined, {
            shallow: true
        });
        return dispatch({
            type: ReducerType.OnPageChange,
            payload: page
        });
    };
    var buildShowFilter = function(state) {
        var _ = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ProductInputKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (state[key]) _.push({
                    key: key,
                    value: state[key]
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _;
    };
    var onKeywordChange = function(value) {
        dispatch({
            type: ReducerType.OnPageChange,
            payload: 1
        });
        if (value.includes("#")) {
            dispatch({
                type: ReducerType.OnKeywordChange,
                payload: ""
            });
            dispatch({
                type: ReducerType.OnTagChange,
                payload: value.replace("#", "")
            });
        } else {
            if (!Router.query.tag) {
                dispatch({
                    type: ReducerType.OnTagChange,
                    payload: ""
                });
            }
            dispatch({
                type: ReducerType.OnKeywordChange,
                payload: value
            });
        }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var onCategoryChange = function(e) {
        var id = e.currentTarget.dataset.id;
        if (id) {
            Router.push({
                pathname: shared/* PagePath.CategoryPage */._.CategoryPage,
                query: {
                    id: id.toLocaleLowerCase()
                }
            });
        }
    };
    var onFilterReset = function() {
        return dispatch({
            type: ReducerType.OnFilterReset
        });
    };
    var removeFilterKey = function(key) {
        dispatch({
            type: ReducerType.OnPageChange,
            payload: 1
        });
        Router.push({
            pathname: Router.pathname,
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Router.query), {
                page: 1
            })
        }, undefined, {
            shallow: true
        });
        if (key === KeyFilter.Color) return dispatch({
            type: ReducerType.OnColorChange,
            payload: ""
        });
        if (key === KeyFilter.GemMaterial) return dispatch({
            type: ReducerType.OnGemMaterialChange,
            payload: ""
        });
        if (key === KeyFilter.GemType) return dispatch({
            type: ReducerType.OnGemTypeChange,
            payload: ""
        });
        if (key === KeyFilter.GemPure) return dispatch({
            type: ReducerType.OnGemPureChange,
            payload: ""
        });
        if (key === KeyFilter.JewelryMaterial) return dispatch({
            type: ReducerType.OnJewelryMaterialChange,
            payload: ""
        });
        if (key === KeyFilter.Price) return dispatch({
            type: ReducerType.OnPriceChange,
            payload: ""
        });
        if (key === KeyFilter.Quotation) return dispatch({
            type: ReducerType.OnQuotationChange,
            payload: ""
        });
        if (key === KeyFilter.SortBy) return dispatch({
            type: ReducerType.OnSortBy,
            payload: ""
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: (category === null || category === void 0 ? void 0 : (ref = category.seo) === null || ref === void 0 ? void 0 : ref.title) || t("list.title"),
                seo: category === null || category === void 0 ? void 0 : category.seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "tw-hidden",
                children: (category === null || category === void 0 ? void 0 : category.product_category_name) || t("list.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "tw-hidden",
                children: (category === null || category === void 0 ? void 0 : category.product_category_name) || t("list.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "tw-hidden",
                children: (category === null || category === void 0 ? void 0 : category.description) || t("list.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "tw-hidden",
                children: (category === null || category === void 0 ? void 0 : category.description) || t("list.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:tw-pb-16 ".concat(Router.query.tag ? "md:tw-border-t tw-border-primary-main" : ""),
                children: [
                    !Router.query.tag && (category === null || category === void 0 ? void 0 : category.banner_images) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-block tw-relative tw-w-full tw-pb-40-percent md:tw-pb-35-percent",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                            className: "tw-h-full tw-w-full !tw-absolute tw-left-0 tw-top-0",
                            src: category.banner_images.url,
                            alt: category.product_category_name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "main-category",
                        children: Router.query.tag ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-pt-4 tw-text-secondary-70 container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                    className: "!tw-text-secondary-70",
                                    url: {
                                        pathname: shared/* PagePath.ProductsPage */._.ProductsPage
                                    },
                                    children: t("detail.product")
                                }),
                                " > #".concat(Router.query.tag)
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-bg-white tw-bg-center tw-bg-cover tw-bg-no-repeat tw-py-4 md:tw-hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container tw-flex tw-flex-col tw-gap-y-4 tw-px-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-w-full md:tw-max-w-max tw-flex tw-flex-col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-mt-4 tw-block md:tw-hidden",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter, {
                                                t: t,
                                                categories: categories,
                                                masterDataPearl: masterDataPearl,
                                                masterData: masterData,
                                                state: state,
                                                dispatch: dispatch
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container tw-mx-auto tw-mt-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "tw-uppercase tw-text-2xl tw-text-secondary-70 tw-font-bold",
                                children: (category === null || category === void 0 ? void 0 : category.product_category_name) || t("list.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-4 md:tw-mt-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-col-span-1 md:tw-col-span-4 tw-flex tw-flex-col tw-gap-y-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "md:tw-grid tw-grid-cols-12 tw-gap-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tw-col-span-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-hidden md:tw-block",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter, {
                                                        t: t,
                                                        categories: categories,
                                                        masterDataPearl: masterDataPearl,
                                                        masterData: masterData,
                                                        state: state,
                                                        dispatch: dispatch
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                            children: (!!buildShowFilter(state).length || state.price || state.product_keyword) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                                className: "sort tw-grid tw-grid-cols-4 md:tw-grid-cols-5 tw-gap-x-4",
                                                initial: {
                                                    opacity: 0
                                                },
                                                animate: {
                                                    opacity: 1
                                                },
                                                exit: {
                                                    opacity: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-col-span-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                                            onClick: onFilterReset,
                                                            variant: components/* ButtonVariant.Outlined */.Wu.Outlined,
                                                            className: "!tw-rounded-5 tw-px-3 tw-py-1 !tw-border-gray-31 tw-text-base tw-w-full tw-text-secondary-70",
                                                            children: t("list.btn.reset")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "tw-col-span-3 md:tw-col-span-4 tw-flex tw-flex-wrap tw-gap-x-4 tw-gap-y-2",
                                                        children: [
                                                            buildShowFilter(state).map(function(item) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "tw-rounded-full tw-px-3 tw-py-1 tw-text-base tw-flex tw-justify-between tw-items-center tw-w-max tw-bg-primary-50 tw-border tw-border-primary-70 hover:tw-border-primary-main tw-text-primary-main",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "tw-mr-3",
                                                                            children: item.value
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "tw-w-5 tw-h-5 tw-flex tw-justify-center tw-items-center tw-cursor-pointer",
                                                                            onClick: function() {
                                                                                return removeFilterKey(item.key);
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                                                className: "!tw-w-2 !tw-h-2 tw-text-primary-main tw-flex tw-items-center tw-justify-center",
                                                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* XLineIcon */.pC, {})
                                                                            })
                                                                        })
                                                                    ]
                                                                }, item.key);
                                                            }),
                                                            state.price && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "tw-rounded-full tw-px-3 tw-py-1 tw-text-base tw-flex tw-justify-between tw-items-center tw-w-max tw-bg-primary-50 tw-border tw-border-primary-70 hover:tw-border-primary-main tw-text-primary-main",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "tw-mr-3",
                                                                        children: (ref1 = priceFilter.find(function(v) {
                                                                            return v.value == state.price;
                                                                        })) === null || ref1 === void 0 ? void 0 : ref1.text
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "tw-w-5 tw-h-5 tw-flex tw-justify-center tw-items-center tw-cursor-pointer",
                                                                        onClick: function() {
                                                                            return removeFilterKey("price");
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                                            className: "!tw-w-2 !tw-h-2 tw-text-primary-main tw-flex tw-items-center tw-justify-center",
                                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* XLineIcon */.pC, {})
                                                                        })
                                                                    })
                                                                ]
                                                            }, "price")
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        state.product_keyword && (!cursor.edges.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-text-secondary-70",
                                            children: [
                                                t("list.no-product"),
                                                " ",
                                                '"',
                                                state.product_keyword,
                                                '"'
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-text-secondary-70",
                                            children: [
                                                t("list.label.resultSearch"),
                                                " ",
                                                '"',
                                                state.product_keyword,
                                                '"'
                                            ]
                                        })),
                                        !Router.query.tag && state.tags && (!cursor.edges.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-text-secondary-70",
                                            children: [
                                                t("list.no-product"),
                                                " ",
                                                '"',
                                                "#",
                                                state.tags,
                                                '"'
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-text-secondary-70",
                                            children: [
                                                t("list.label.resultSearch"),
                                                " ",
                                                '"',
                                                "#",
                                                state.tags,
                                                '"'
                                            ]
                                        })),
                                        !state.product_keyword && !!buildShowFilter(state).length && !cursor.edges.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-text-secondary-70",
                                            children: t("list.no-product")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                            children: !!cursor.edges.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                                initial: {
                                                    opacity: 0
                                                },
                                                animate: {
                                                    opacity: 1
                                                },
                                                exit: {
                                                    opacity: 0
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* default */.Z, {
                                                    catCode: category.code,
                                                    t: t,
                                                    edges: cursor.edges,
                                                    isLoading: isLoading
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-flex tw-justify-end",
                                            children: (0,app/* getTotalPage */.VC)(cursor.count, state.limit) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Pagination */.tl, {
                                                onPageChange: onPageChange,
                                                page: (0,app/* getCurrentPage */.FZ)(state.limit, state.offset),
                                                count: (0,app/* getTotalPage */.VC)(cursor.count, state.limit)
                                            })
                                        }),
                                        !cursor.edges.length && !!newestProducts.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-mt-10 tw-hidden lg:tw-block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProduct/* default */.Z, {
                                                title: t("list.label.related-products"),
                                                cateCode: category.code,
                                                products: newestProducts,
                                                t: t,
                                                isHideSeeMore: true
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var layout = (ProductListLayout);

;// CONCATENATED MODULE: ./features/products/list/index.ts

/* harmony default export */ var list = (layout);


/***/ }),

/***/ 71319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_loop_ProductLoop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90884);



var ItemPartial = function(param) {
    var edges = param.edges, isLoading = param.isLoading, catCode = param.catCode, t = param.t;
    console.log(catCode);
    if (isLoading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-x-2 tw-gap-y-4 md:tw-gap-x-4 ",
        children: Array(18).fill(1).map(function(p, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loop_ProductLoop__WEBPACK_IMPORTED_MODULE_2__/* .ProductLoopLoading */ .P, {}, "loading-".concat(index));
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-x-2 tw-gap-y-4 md:tw-gap-x-4 ",
        children: edges.map(function(p) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loop_ProductLoop__WEBPACK_IMPORTED_MODULE_2__/* .ProductLoop */ ._, {
                p: p,
                t: t,
                catCode: catCode
            }, p.product_code);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ItemPartial);


/***/ })

}]);